module.exports = __webpack_public_path__ + "static/media/left.443581c8.svg";